/* unplugin-vue-components disabled */import script from "./MerchandiseBlacklistModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MerchandiseBlacklistModal.vue?vue&type=script&setup=true&lang=js"

import "./MerchandiseBlacklistModal.vue?vue&type=style&index=0&id=6baf7e6e&scoped=true&lang=css"

import exportComponent from "/data/jenkins/workspace/wyt-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6baf7e6e"]])

export default __exports__